// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <div>
    <v-data-table
      v-bind:headers="headers"
      disable-initial-sort
      :items="flavors"
      :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
      no-data-text="No License Types"
      >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">
          {{ getDuration(props.item.duration) }}
        </td>
        <td class="text-xs-left">
          {{ getLicenseFlavorText(props.item.flavor) }}
        </td>
        <td style="width: 1%; padding: 0px;">
          <v-btn title="Edit" icon flat v-if="canModify" @click="editLicense(props.index)"><v-icon>edit</v-icon></v-btn>
        </td>
        <td style="width: 1%; padding: 0px;">
          <v-btn title="Delete" icon flat v-if="canModify" @click="deleteLicense(props.index)"><v-icon>delete</v-icon></v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="showDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="title">
          Edit License Type
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              label="Duration (days)"
              :value="getDuration(editLic.duration)"
              @input="(val) => setDuration(val)"
              mask="######"
              required
              :rules="[ruleRequired(editLic.duration)]"
            ></v-text-field>
            <v-autocomplete
              label="License Flavor"
              item-text="name"
              item-value="id"
              v-bind:items="licenseFlavors"
              v-model="editLic.flavor"
              required
              :rules="[ruleRequired(editLic.flavor)]"
            ></v-autocomplete>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" flat @click.stop="addItem">Add</v-btn>
          <v-btn color="error" flat @click.stop="cancelDialog()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn fab dark class="green" @click.stop="addLicense()" id="addButton" v-if="canModify"><v-icon>add</v-icon></v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import DateView from '@/shared/DateView'
import {checkPermission} from 'vue-common/components/user'
import {PERMISSIONS} from 'vue-common/components/constants'

export default {
  name: 'license-types',

  components: {
    DateView
  },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      licenseFlavors: [],
      flavors: this.value,
      editLic: {},
      itemIndex: null,
      origItem: {},
      headers: [
        {
          text: 'Duration (days)',
          value: 'duration'
        },
        {
          text: 'License Flavor',
          value: 'flavor'
        }
      ],
      showDialog: false,
      valid: null
    }
  },

  created () {
    ApiRequests.getLicenseFlavors().then((response) => {
      this.licenseFlavors = response.data
    })
  },

  computed: {
    ...mapGetters([
      'accessRules'
    ]),

    canModify: function () {
      return checkPermission(this.accessRules, 'items', PERMISSIONS.MODIFY)
    }
  },

  watch: {
    flavors () {
      this.$emit('input', this.flavors)
    },

    value (val) {
      if (this.value === null) {
        this.flavors = []
      } else {
        this.flavors = this.value
      }
    }
  },

  methods: {
    addLicense: function () {
      this.itemIndex = null
      this.flavors.push({})
      this.showDialog = true
      this.editLic = this.flavors[this.flavors.length - 1]
    },

    addItem: function () {
      console.log(this.editLic)
      if (this.$refs.form.validate()) {
        this.editLic.count = Number(this.editLic.count)
        this.$set(this.flavors, this.itemIndex, this.editLic)
        this.showDialog = false
      }
      console.log(this.flavors)
    },

    cancelDialog: function () {
      if (this.itemIndex === null) {
        this.flavors.splice(this.flavors.length - 1, 1)
      } else {
        this.$set(this.flavors, this.itemIndex, this.origItem)
      }
      this.showDialog = false
    },

    deleteLicense: function (index) {
      this.flavors.splice(index, 1)
    },

    editLicense: function (index) {
      this.itemIndex = index
      this.editLic = this.flavors[index]
      this.origItem = Object.assign({}, this.editLic)
      this.showDialog = true
    },

    getDuration: function (value) {
      return value / 86400000000000
    },

    getLicenseFlavorText: function (flavor) {
      var full = this.licenseFlavors.find(el => el.id === flavor)
      if (full) {
        return full.name
      }
      return 'n/a'
    },

    ruleRequired: function (value) {
      if (value !== null && value !== '' && value !== [] && value !== undefined) {
        return true
      }
      return 'Please input a valid number.'
    },

    setDuration: function (value) {
      this.editLic.duration = value * 86400000000000
    }
  }
}
</script>

<style scoped>
  #addButton {
    position: relative;
    overflow: hidden;
    position: fixed;
    bottom: 20px !important;
    right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/LicenseTypes.vue